export class FlightPriceBreakdown {
  private operatorPrice: number;
  private flightPrice: number;
  private commission: number;

  constructor(operatorPrice?: number, flightPrice?: number, commission?: number) {
    this.operatorPrice = operatorPrice;
    this.flightPrice = flightPrice;
    this.commission = commission;
  }

  getOperatorPrice(): number {
    return this.operatorPrice;
  }

  setOperatorPrice(operatorPrice: number): FlightPriceBreakdown {
    this.operatorPrice = operatorPrice;
    return this;
  }

  getFlightPrice(): number {
    return this.flightPrice;
  }

  setFlightPrice(flightPrice: number): FlightPriceBreakdown {
    this.flightPrice = flightPrice;
    return this;
  }

  getCommission(): number {
    return this.commission;
  }

  setCommission(commission: number): FlightPriceBreakdown {
    this.commission = commission;
    return this;
  }
}
